"use client";

/** Çerez tercih banner'ını yeniden açar (ret sonrası onay vermek için). */
export function openCookieSettings() {
  window.dispatchEvent(new Event("open-cookie-settings"));
}

export function CookieSettingsButton({ className }: { className?: string }) {
  return (
    <button
      type="button"
      onClick={openCookieSettings}
      className={className ?? "text-lg font-normal text-Primary transition hover:text-Primary-dark hover:underline"}
    >
      Çerez Ayarları
    </button>
  );
}
